import { RebuildNotice } from '@/components/RebuildNotice'
export default function Page() { return <RebuildNotice title="Expenses" hint="Expense + approval queue from the finance engine." /> }
